import React from 'react';
import AisleTesterWithSiteConfig from '../component/aisle-tester-with-site-config';
import AisleTesterWithoutSiteConfig from '../component/aisle-tester-without-site-config';

const AisleTesterPage = (props) => {
    if (props.siteId == null) {
        return <div>Select a site</div>;
    }
    if (props.siteConfig == null) {
        return <AisleTesterWithoutSiteConfig {...props}/>;
    }
    return <AisleTesterWithSiteConfig {...props}/>;
};

export default AisleTesterPage;



// WEBPACK FOOTER //
// ./src/components/devicemanagement/ledcontroller/bintester/view/aisle-tester-page.jsx